if (!customElements.get("product-form")) {
  customElements.define(
    "product-form",
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector("form");
        this.form.querySelector("[name=id]").disabled = false;
        this.form.addEventListener("submit", this.onSubmitHandler.bind(this));
        this.submitButton = this.querySelector('[type="submit"]');
        if (document.querySelector(".cart-drawer"))
          this.submitButton.setAttribute("aria-haspopup", "dialog");
      }

      onSubmitHandler(evt) {
        evt.preventDefault();

        if (this.submitButton.getAttribute("aria-disabled") === "true") return;

        this.submitButton.setAttribute("aria-disabled", true);
        this.submitButton.classList.add("loading");

        const formData = new FormData(this.form);

        const variantId = formData.get("id");

        const payload = {};

        const bundleProp = formData.get("properties[_bundle]");
        if (bundleProp) {
          payload.properties = {
            _bundle: bundleProp,
          };
        }

        const quantity = formData.get("quantity") || 1;

        window.BIRTHDATE_CART.addVariant(
          {
            id: variantId,
          },
          quantity,
          payload,
          {
            ensureUnique: this.dataset.ensureUnique === "true",
          }
        ).finally(() => {
          setTimeout(() => {
            this.submitButton.removeAttribute("aria-disabled");
            this.submitButton.classList.remove("loading");
          }, 10);
        });
      }
    }
  );
}